export const FETCH_BATCH_PROVISIONS_CONNECTIONS_SUCCESS = 'FETCH_BATCH_PROVISIONS_CONNECTIONS_SUCCESS';
export const FETCH_BATCH_PROVISIONS_CONNECTIONS_FAILURE = 'FETCH_BATCH_PROVISIONS_CONNECTIONS_FAILURE';
export const SELECT_CONNECTION_FOR_BATCH_PROVISIONS = 'SELECT_CONNECTION_FOR_BATCH_PROVISIONS';
export const FETCH_BATCH_PROVISIONS_SUCCESS = 'FETCH_BATCH_PROVISIONS_SUCCESS';
export const FETCH_BATCH_PROVISIONS_FAILURE = 'FETCH_BATCH_PROVISIONS_FAILURE';
export const FETCH_BATCH_PROVISIONS = 'FETCH_BATCH_PROVISIONS';
export const SET_PROCESSED_SUCCESSFULLY_FILTER = 'SET_PROCESSED_SUCCESSFULLY_FILTER';
export const UNSET_PROCESSED_SUCCESSFULLY_FILTER = 'UNSET_PROCESSED_SUCCESSFULLY_FILTER';
export const SET_TRIAL_BALANCES_NOT_RECEIVED_FILTER = 'SET_TRIAL_BALANCES_NOT_RECEIVED_FILTER';
export const UNSET_TRIAL_BALANCES_NOT_RECEIVED_FILTER = 'UNSET_TRIAL_BALANCES_NOT_RECEIVED_FILTER';
export const SET_TRIAL_BALANCES_WITH_ERRORS_FILTER = 'SET_TRIAL_BALANCES_WITH_ERRORS_FILTER';
export const UNSET_TRIAL_BALANCES_WITH_ERRORS_FILTER = 'UNSET_TRIAL_BALANCES_WITH_ERRORS_FILTER';
export const SET_CALCULATION_ERRORS_FILTER = 'SET_CALCULATION_ERRORS_FILTER';
export const UNSET_CALCULATION_ERRORS_FILTER = 'UNSET_CALCULATION_ERRORS_FILTER';
export const SET_OTHER_ERRORS_FILTER = 'SET_OTHER_ERRORS_FILTER';
export const UNSET_OTHER_ERRORS_FILTER = 'UNSET_OTHER_ERRORS_FILTER';
export const SET_JOURNALS_FILTER = 'SET_JOURNALS_FILTER';
export const UNSET_JOURNALS_FILTER = 'UNSET_JOURNALS_FILTER';
export const SET_LOCAL_JOURNALS_FILTER = 'SET_LOCAL_JOURNALS_FILTER';
export const UNSET_LOCAL_JOURNALS_FILTER = 'UNSET_LOCAL_JOURNALS_FILTER';
export const INITIATE_CALC = 'INITIATE_CALC';
export const INITIATE_CALC_FAILURE = 'INITIATE_CALC_FAILURE';
export const INITIATE_CALC_SUCCESS = 'INITIATE_CALC_SUCCESS';
export const UPDATE_CONNECTION_STATUS = 'UPDATE_CONNECTION_STATUS';
export const FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION = 'FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION';
export const FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION_SUCCESS = 'FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION_SUCCESS';
export const FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION_FAILURE = 'FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION_FAILURE';
